var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_111_503)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_111_503",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_111_503",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_111_503",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC80lEQVR4nO3dvYsTQQAF8MXPQyuxERVEr9NGRFBBQa0UsbWwEEHtVFDsBPf+AiEm7Lw3txBIGcRCwT9B7bQTFcROLUQkFqfCjQymlOxmPyZh8h68Lrm8/C4XcpvNXZIoiqIoiqLMZUi6RSqAnyRfkbzd6XS2CppB+sZau1fQDIMd5JE9B3fUzboAbgmaQaBfCppBOhI0w1TQFLSLqYKmoF1MFTQF7WKqoCloF1MFTUG7mCpoCtpVKYBvJDOS5621+weDwXaS20geAfCQ5G9B12/e7XZ3Fuw5Q3JN0NUfyekUmy6QXPWHLwXNqZCfVdmW5/k+AB8EzVL948Gq7gNwFMC6oFnYp3U3AnguaE6utfZG3Y3+awiahdCH62601h4XNCe36OVcmfjneEGzsJvrbuz3+0uC5uRmWbaj7kb/UyFoTi6AEw1sPCZoFvZBAxvvC5qFNQ1sNILm5GZZdqCBjcuCZmGXG9goaBbUGHOl7kZr7VVBc3IBvPMH+Kvu89cl+V7QLNW3Vff5b1SIjUkk0M4Yc3DabdbaQ6H2JW0n1B0B8HjabQCeCJqVernsLmvtpZDbYoMekTxZAvnU+POAgmb1rpTYtBJ6l6ApaCfoOYUGsG6MOV20yV8mxDvfUUID+DXNJ1T9Zf11BM3SwF9IPqpycGl8MKlD8rOg+V/c7wAGAC428Z5hmqYb/MvCMfrXhYfGv9O3rrf51wKGw+EWY8y1pk8VS9pOQ0PXSN4ZDocbk0Dxt+Vvs6kzT1sf3AQygHPJjOJvuwns1oc28HRxt/WRxffhXtTQAD6labopmXH80wiAjzFDp8mcpO5vkyEGVh5nSvyWFyrW2rPRQvd6vV3JnCTP893RQvf7/aVkTlL3RMjWB9YZx4gqaAraxVRBU9AupgqagnYxVdAUtIupgqagXUwVNAXtYqqgKWgXUwXNIP0haLZf/TMFButNQbP1R/Nrf5qZoNkusjFmT+vICwo9IvnCP10EeSQriqIoiqIkdfIXEMubckydq64AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/Contacts.99fb540c8a5ae4647aa4a3718657ea8b.svg";
export { ForwardRef as ReactComponent };